function getCookie(cname) {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function cookieExists(cookieName) {
  const cookie = getCookie(cookieName);
  return cookie !== '';
}

function deleteCookie(name) {
  if (getCookie(name)) {
    document.cookie = name + '=true' +
      ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
  }
}

export {cookieExists, getCookie, deleteCookie};
